import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://www.exhibirte.com';
const DEFAULT_SEO = {
  title: 'Exhibirte Uruguay | Stands, Cartelería y Comunicación Visual',
  description: 'Diseño, fabricación e instalación de stands, cartelería, exhibidores y soluciones de comunicación visual para empresas en Uruguay.'
};

const PAGE_SEO = {
  '/': DEFAULT_SEO,
  '/nosotros': { title: 'Sobre Exhibirte | Comunicación Visual en Uruguay', description: 'Conocé Exhibirte: un equipo de Uruguay que diseña, produce e instala soluciones de comunicación visual, stands, cartelería y exhibidores.' },
  '/contacto': { title: 'Contacto | Exhibirte Uruguay', description: 'Contactá a Exhibirte para consultar sobre stands, cartelería, exhibidores, mobiliario para eventos y comunicación visual en Uruguay.' },
  '/proyectos': { title: 'Trabajos y Proyectos | Exhibirte Uruguay', description: 'Conocé proyectos de stands, cartelería, exhibidores y comunicación visual realizados por Exhibirte en Uruguay.' },
  '/clientes': { title: 'Clientes | Exhibirte Uruguay', description: 'Marcas, empresas e instituciones que confían en Exhibirte para desarrollar soluciones de comunicación visual en Uruguay.' },
  '/capacidades-produccion': { title: 'Capacidades de Producción | Exhibirte Uruguay', description: 'Conocé las capacidades de diseño, fabricación, impresión, corte y producción de Exhibirte para proyectos de comunicación visual.' },
  '/diseno-fabricacion-stands': { title: 'Diseño y Fabricación de Stands | Exhibirte Uruguay', description: 'Diseñamos, fabricamos e instalamos stands a medida para ferias, exposiciones, activaciones y eventos en Uruguay.' },
  '/alquiler-mobiliario-eventos': { title: 'Alquiler de Mobiliario para Eventos | Exhibirte Uruguay', description: 'Alquiler de sillas, mesas, sofás, mostradores, decoración y accesorios para eventos, ferias y exposiciones en Uruguay.' },
  '/pantallas-tactiles': { title: 'Pantallas Táctiles para Eventos | Exhibirte Uruguay', description: 'Alquiler de pantallas táctiles y soluciones interactivas para eventos, ferias, exposiciones y activaciones en Uruguay.' },
  '/pantallas-soluciones-interactivas': { title: 'Pantallas y Soluciones Interactivas | Exhibirte Uruguay', description: 'Pantallas LED, tótems digitales e interactivos, mapping y aplicaciones a medida para eventos y espacios comerciales en Uruguay.' },
  '/exhibidores-modulares-easyclick': { title: 'EasyClick: Exhibidores Modulares | Exhibirte Uruguay', description: 'Conocé EasyClick, el sistema de exhibidores y mobiliario modulares de Exhibirte para puntos de venta y comercios.' },
  '/servicios/carteleria': { title: 'Exhibición y Cartelería | Exhibirte Uruguay', description: 'Exhibición en punto de venta, cartelería, señalización, fachadas comerciales, gráfica y ploteos para marcas en Uruguay.' }
};

const updateMeta = (selector, attribute, value) => {
  const element = document.head.querySelector(selector);
  if (element) element.setAttribute(attribute, value);
};

const PageSeo = () => {
  const { pathname } = useLocation();
  const canonicalPath = pathname.replace(/\/+$/, '') || '/';
  const seo = PAGE_SEO[canonicalPath] || DEFAULT_SEO;
  const canonicalUrl = `${SITE_URL}${canonicalPath}`;

  useEffect(() => {
    document.title = seo.title;
    updateMeta('meta[name="title"]', 'content', seo.title);
    updateMeta('meta[name="description"]', 'content', seo.description);
    updateMeta('meta[property="og:title"]', 'content', seo.title);
    updateMeta('meta[property="og:description"]', 'content', seo.description);
    updateMeta('meta[property="og:url"]', 'content', canonicalUrl);
    updateMeta('meta[name="twitter:title"]', 'content', seo.title);
    updateMeta('meta[name="twitter:description"]', 'content', seo.description);
    updateMeta('meta[name="twitter:url"]', 'content', canonicalUrl);
    updateMeta('link[rel="canonical"]', 'href', canonicalUrl);
  }, [canonicalUrl, seo]);

  return null;
};

export default PageSeo;

